import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Configuration } from 'app/app.constants';
import { LegendItem } from '../dashboard.types';

@Component({
  selector: 'statuses-legend',
  templateUrl: './statuses-legend.component.html',
  styleUrls: ['./statuses-legend.component.scss']
})
export class StatusesLegendComponent implements OnChanges {

  @Input() cegFlagEnabled = false;
  @Input() isManageTableTimeline = false;
  @Input() availableLegends: string[] = [];

  legendData: LegendItem[][];
  legendDataCeg: LegendItem[];
  private legendDataCegBase: LegendItem[];

  constructor(private config: Configuration) {
    const { closed, committed, planned } = config.expenseStatusesDescriptions;
    const { remainingBudget, remainingAllocated, underBudget, overBudget } = config.budgetStatusesDescriptions;
    const { statusFields } = config;

    this.legendData = [
      [
        { title: 'Closed', tooltipDesc: closed, status: statusFields.closed },
        { title: 'Committed', tooltipDesc: committed, status: statusFields.committed },
        { title: 'Planned', tooltipDesc: planned, status: statusFields.planned },
      ],
      [
        { title: 'Remaining Budget', tooltipTitle: 'Remaining Budget', tooltipDesc: remainingBudget, status: statusFields.budgetRemainingAmount },
        { title: 'Remaining Allocated', tooltipTitle: 'Remaining Allocated', tooltipDesc: remainingAllocated, status: statusFields.remainingAllocated },
        { title: 'Under Budget', tooltipDesc: underBudget, status: statusFields.underBudget },
        { title: 'Over Budget', tooltipDesc: overBudget, status: statusFields.overBudget },
      ]
    ];

    this.legendDataCegBase = [
      { title: 'Forecast', status: statusFields.forecast },
      { title: 'Actual Spend', status: statusFields.actual },
      { title: 'Remaining Committed Budget', status: statusFields.committed },
      { title: 'Remaining Planned Budget', status: statusFields.planned },
      { title: 'Available Budget', status: statusFields.budgetRemainingAmount },
      { title: 'Over Budget', status: statusFields.overBudget },
    ];

    this.legendDataCeg = [...this.legendDataCegBase];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['availableLegends'] && this.cegFlagEnabled) {
      const available = changes['availableLegends'].currentValue;

      if (Array.isArray(available) && available.length > 0) {
        this.legendDataCeg = this.legendDataCegBase.filter(item =>
          available.includes(item.title) || item.title === 'Available Budget'
        );
      } else {
        this.legendDataCeg = [...this.legendDataCegBase];
      }
    }
  }
  
}